import {
  SetOnLineStatusAction,
  ApplicationStateActionName,
  SetTotalStorageUsedAction,
  SetSaveFailedDueToStorageAction,
} from 'src/researcher/types/application';

export const setOnLineStatusAction = (onLine: boolean): SetOnLineStatusAction => ({
  type: ApplicationStateActionName.SetOnLineStatus,
  payload: {
    onLine,
  },
});

export const setTotalStorageUsedAction = (totalStorageUsed: number): SetTotalStorageUsedAction => ({
  type: ApplicationStateActionName.SetTotalStorageUsed,
  payload: {
    totalStorageUsed,
  },
});

export const setSaveFailedDueToStorageAction = (
  saveFailedDueToStorage: boolean,
  singleDocumentSizeReached: boolean
): SetSaveFailedDueToStorageAction => ({
  type: ApplicationStateActionName.SetSaveFailedDueToStorage,
  payload: {
    saveFailedDueToStorage,
    singleDocumentSizeReached,
  },
});
